import { $, on } from "@olmokit/dom";
import AuthFormPasswordRecovery from "@olmokit/core/auth/form-password-recovery";
import "@olmokit/core/forms/input/filled";
import "@olmokit/core/forms/checkbox";
import "./Password.scss";

/**
 * Component: AuthPasswordRecovery
 */
export function AuthPassword($root?: HTMLElement) {

  const $back = $('.AuthPassword:back');
  const $formpassword = $('.form-password');
  const $formlogin = $('.form-login');
  on($back, 'click', () => {
    $formlogin.style.display = 'block';
    $formpassword.style.display = 'none';
  });    

  const $error = $(".AuthPassword: .error");
  AuthFormPasswordRecovery($root, {
    succeded: (formData, instance, response) => {
      $error.innerHTML = response?.data?.msg || "";
      const $password = $('#of-password-recovery-email');
      $password.value = '';
    },
    failed: (formData, instance, response) => {
      $error.innerHTML = response.data;
    },
  });   

}
